import Model from './Model'

export default class ListLead extends Model {
    resource() {
        return 'listlead'
    }

}
